<template>
  <my-modal>
    <div class="modal-container">
      <div class="modal-header text-center">
        <h3 class="text-center">Imprimir listado de artículos</h3>
        <button type="button" class="close" @click="cerrarModal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        class="modal-body justify-content-center"
        style="max-height:100%!important;height:auto!important;overflow:visible;"
      >
        <div class="row w-100">
          <FloatLabel label="Tipo de listado: " clase=" col-md-6 col-12">
            <select
              id="tipoListado"
              class="form-control"
              v-model="tipoListado"
            >
              <option value="normal">Listado normal (PDF)</option>
              <option value="codigo_stock">Código y stock (Excel)</option>
            </select>
          </FloatLabel>
          <FloatLabel label="Ordenar por: " clase=" col-md-6 col-12" v-if="tipoListado == 'normal'">
            <select
              id="orden"
              class="form-control"
              :class="(enviado && !$v.orden.required) ? 'is-invalid' : ''"
              v-model="orden"
            >
              <option :value="null">Seleccione orden</option>
              <option value="codigo">Código</option>
              <option value="descripcion">Descripcion</option>
            </select>
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.orden.required"
              >Debe seleccionar orden</div>
            </template>
          </FloatLabel>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="row w-100">
          <div class="col-md-4">
            <button class="btn btn-danger btn-block mb-2" @click="cerrarModal">Cerrar</button>
          </div>
          <div class="col-md-4 offset-md-4">
            <button class="btn btn-info btn-block mb-2" @click="mostrarPDF">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
  </my-modal>
</template>
<script>
import MyModal from "@/components/layouts/MyModal";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from "vuelidate/lib/validators";
import axios from 'axios'
export default {
  name: "ModalListadoArticulos",
  components: {
    MyModal,
    FloatLabel
  },
  data() {
    return {
      orden: null,
      enviado: false,
      tipoListado: 'normal'
    };
  },
  validations: {
    orden: { required },
  },
  created(){
    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      this.cerrarModal()
      next(false)
    })

    this.$once('hook:destroyed', () => {
      unregisterRouterGuard()
    })
  },
  methods: {
    mostrarPDF() {
      if (this.tipoListado == 'codigo_stock') {
        this.descargarExcel();
        return;
      }
      this.$v.$touch();
      this.enviado = true;
      if (this.$v.$invalid) {
        return false;
      }
      let url = axios.defaults.baseURL + '/imprimir/listado-stock?order='+this.orden;
      window.open(url);
    },
    descargarExcel() {
      axios
        .get("/exportar-stock-codigo", { responseType: "blob" })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "listado_codigo_stock.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cerrarModal() {
      this.$emit("cerrarListadoArticulo");
    }
  }
};
</script>